<template>
  <b-row>
    <b-col cols="8">
      <ClueManage :mode="'GCC'" :gcc="gccId" ref="formData" />
    </b-col>
    <b-col cols="4">
      <GccDetail :gccObj="gccDetail"> </GccDetail>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import ClueManage from "@/views/Complaint/clue/cluemanage/ClueOcpbCareManage.vue";
import GccDetail from "./components/GCCDetail.vue";

import * as gccStore from "@/store/api/gcc/index.js";

export default {
  components: {
    BRow,
    BCol,
    ClueManage,
    GccDetail,
  },
  data() {
    return {
      gccDetail: {
        rootobject: {},
      },
      gccId: this.$route.query.id,
    };
  },
  mounted() {
    this.getGccApi();
  },
  methods: {
    getGccApi() {
      const _this = this;
      gccStore
        .getApiById(this.$route.query.id)
        .then((response) => {
          _this.$refs.formData.$data.clueData.clueDetail =
            "(" +
            response.data.data.rootobject.case_code +
            ") - " +
            response.data.data.rootobject.detail;
          _this.$refs.formData.$data.clueData.gccId =
            response.data.data.rootobject.case_id;
          _this.gccDetail = response.data.data;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
